import {
  NS_POST_CREATE_TICKET,
  NS_POST_CREATE_TICKET_FAIL,
  NS_POST_CREATE_TICKET_SUCCESS,
  NS_GET_CURRENT_CHAMPION,
  NS_GET_CURRENT_CHAMPION_SUCCESS,
  NS_GET_CURRENT_CHAMPION_FAIL,
  NS_GET_CHAMPION_CHALLENGER_DETAILS,
  NS_GET_CHAMPION_CHALLENGER_DETAILS_SUCCESS,
  NS_GET_CHAMPION_CHALLENGER_DETAILS_FAIL
} from '../../actions/ns/tickets';

import { GET_AMLS_COMMON_TICKETS } from '../../actions/common';

export const initialState = {
  createTicket: { isLoading: false, error: null, data: null },
  currentChampion: { isLoading: false, error: null, data: null },
  championChallengerDetails: {
    isChampionLoading: false,
    isChallengerLoading: false,
    data: null,
    error: null
  }
};

function nsTickets(state = initialState, action) {
  switch (action.type) {
    case NS_POST_CREATE_TICKET:
      return {
        ...state,
        createTicket: { isLoading: true, error: null, data: null }
      };
    case NS_POST_CREATE_TICKET_SUCCESS:
      return {
        ...state,
        createTicket: { isLoading: false, data: action.payload, error: null }
      };
    case NS_POST_CREATE_TICKET_FAIL:
      return {
        ...state,
        createTicket: { isLoading: false, data: null, ...action.payload }
      };
    case NS_GET_CURRENT_CHAMPION:
      return {
        ...state,
        currentChampion: { isLoading: true, error: null, data: null }
      };
    case NS_GET_CURRENT_CHAMPION_SUCCESS:
      return {
        ...state,
        currentChampion: { isLoading: false, data: action.payload, error: null }
      };
    case NS_GET_CURRENT_CHAMPION_FAIL:
      return {
        ...state,
        currentChampion: { isLoading: false, data: null, ...action.payload }
      };
    case GET_AMLS_COMMON_TICKETS:
      return {
        ...initialState
      };
    case NS_GET_CHAMPION_CHALLENGER_DETAILS:
      return {
        ...state,
        championChallengerDetails: {
          ...state.championChallengerDetails,
          isChampionLoading: false,
          isChallengerLoading: false,
          error: null,
          ...action.payload.loading
        }
      };
    case NS_GET_CHAMPION_CHALLENGER_DETAILS_SUCCESS:
      return {
        ...state,
        championChallengerDetails: {
          ...state.championChallengerDetails,
          data: {
            ...state.championChallengerDetails.data,
            ...action.payload.data
          },
          error: null,
          ...action.payload.loading
        }
      };
    case NS_GET_CHAMPION_CHALLENGER_DETAILS_FAIL:
      return {
        ...state,
        championChallengerDetails: {
          ...state.championChallengerDetails,
          data: null,
          ...action.payload.error,
          ...action.payload.loading
        }
      };
    default:
      return {
        ...state
      };
  }
}

export default nsTickets;
